import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';

const baseRoutes: RouteRecordRaw[] = [
  {
    path: '/billing/ws-:workspaceId',
    name: 'Billing',
    component: () => import('@/pages/MainView.vue'),
    props: (r) => ({
      workspaceId: r.params['workspaceId'],
      origin: r.query['origin']
    }),
    meta: {
      title: 'Billing',
      requireValidationSession: true,
    },
    children: [
      {
        path: 'subscribe',
        name: 'Subscribe',
        component: () => import('@/components/dialogs/SubscribeDialog.vue'),
        meta: {
          openDialog: 'subscribe'
        }
      },
      {
        path: 'manage-authors',
        name: 'ManageAuthors',
        component: () => import('@/components/dialogs/ManageSeatsDialog.vue'),
        meta: {
          openDialog: 'manage-authors'
        }
      },
      {
        path: 'add-to-subscription',
        name: 'AddToSubscription',
        component: () => import('@/components/dialogs/ManageSeatsDialog.vue'),
        meta: {
          openDialog: 'add-to-subscription'
        }
      },
    ]
  },
  {
    path: '/forbidden',
    name: 'Forbidden',
    component: () => import('@/pages/ErrorPage.vue'),
    props: () => ({
      errorCode: 403,
      showErrorCode: false,
    }),
    meta: {
      title: 'Forbidden',
      requireValidationSession: true,
    }
  },
  {
    path: '/upload-po/:quoteId',
    name: 'AnonymousUploadPO',
    component: () => import('@/pages/AnonymousUploadPO.vue'),
    props: (r) => ({
      quoteId: r.params['quoteId'],
    }),
    meta: {
      title: 'Upload Purchase Order',
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Http404',
    component: () => import('@/pages/Http404.vue'),
    props: () => ({
      errorCode: 404,
    }),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: baseRoutes,
});

router.onError((error) => {
  if (error.message.includes("Failed to fetch dynamically imported module")
    || error.message.includes("Importing a module script failed")
    || error.message.includes("Loading chunk")) {
    console.error(error.message);
    setTimeout(() => {
      window.location.reload();
    }, 3000);
  }
});

export default router;
